import * as React from 'react';
import SummaryItem from './SummaryItem';
import { Summary } from '../Models/Report';
import PieChart from './PieChart';
import './CardSummary.scss';
import SummaryTitleItem from './SummaryTitleItem';
import Box from './Box';
import Emply from 'antd/lib/empty';

export interface ICardSummaryProps {
	data: Summary[];
	titleGraph: string;
	titleItem: string;
	loading: boolean;
	header: string | React.ReactElement;
}
const order = (a: Summary, b: Summary) => {
	if (a.total > b.total) {
		return -1;
	}
	if (b.total > a.total) {
		return 1;
	}
	return 0;
};
const CardSummary = (props: ICardSummaryProps) => {

	return (<div className="CardSummary">
	{!props.loading && props.header}
	<Box loading={props.loading}>
	<div className="CardSummary-Charts">
		<h1>{props.titleGraph}</h1>
		<PieChart loading={props.loading} data={props.data} />
	</div>
	{props.data.length > 0  && props.data[0].total > 0 ? <div className="CardSummary-Labels">
		<SummaryTitleItem titleItem={props.titleItem} />
		{props.data.sort(order).map(s => <SummaryItem key={`summary-item-${s.name}`} data={s} />)}
	</div> :
	<div className="CardSummary-Labels">
		<Emply style={{ marginTop: '33px' }} description="No tenemos datos para mostrar" />
	</div>}
	</Box>
</div>)
};

export default CardSummary;
